import * as React from 'react'
import { makeStyles } from '@fluentui/react-components'
import InjuryForm from '../../../components/Form/Injury/InjuryForm'

const useStyles = makeStyles({
    container: {},
})

export default function InjuryOverview() {
    const styles = useStyles()
    return (
        <div className={styles.container}>
            <InjuryForm />
        </div>
    )
}
